import { css } from "@emotion/css";

export const rightHeaderContainer = css`
    button {
        margin-left: 12px;
    }
`;

export const defaultButtonCss = css`
    span {
        white-space: nowrap;
    }
`;

// gives the button enough room to not be cut off
export const addLensButtonCss = css`
    margin-right: 2px;
    ${defaultButtonCss}
`;
